import { IconType } from "@jsq/ds/icons";
import { RiskRating } from "~/graphql/supergraphEnums";
import { RiskRating as RiskRatingType } from "~/graphql/supergraphTypes";
import { RISK_RATING_PROPS } from "~/pages/Compliance/riskRating/constants";
import { getEffectiveRiskRating, RiskRatingOrNull } from "../../utils/riskRatingCalculations";
import { RiskRatingProps } from "./types";

export const getLinkedRisk = (data?: RiskRatingProps["data"]): RiskRatingType => {
  const beneficiaryId = data?.linkedOnboardingCase?.paymentAccount?.profileId;
  const profiles = data?.linkedOnboardingCase?.profiles || [];
  const investingProfile = data?.linkedOnboardingCase?.investingProfile;
  // First check if beneficiaryId matches any child profile
  const beneficiaryProfile = profiles.find((profile) => profile.id === beneficiaryId);

  if (beneficiaryProfile) {
    return getEffectiveRiskRating(beneficiaryProfile.riskRating);
  }

  // Otherwise, check if investingProfile has payment accounts (meaning it's the beneficiary)
  if (investingProfile?.paymentAccounts && investingProfile.paymentAccounts.length > 0) {
    return getEffectiveRiskRating(investingProfile.riskRating);
  }

  return RiskRating.None;
};

export const getInvestorRisk = (data?: RiskRatingProps["data"]): RiskRatingType => {
  return getEffectiveRiskRating(data?.linkedOnboardingCase?.investingProfile?.riskRating);
};

export const getSimulatedRisk = (
  type: keyof Required<NonNullable<RiskRatingProps["data"]>>["simulatedRiskRating"],
  data?: RiskRatingProps["data"],
): RiskRating => {
  const rating = data?.simulatedRiskRating?.[type] ?? RiskRating.None;
  return rating as RiskRating;
};

export const calculateRiskRatingChange = (
  currentRiskRating: RiskRatingOrNull,
  proposedRiskRating: RiskRatingOrNull,
): IconType | undefined => {
  if (!currentRiskRating || !proposedRiskRating) return undefined;

  const current = RISK_RATING_PROPS[currentRiskRating]?.sortPosition ?? 0;
  const proposed = RISK_RATING_PROPS[proposedRiskRating]?.sortPosition ?? 0;
  if (current > proposed) return "arrow-down";
  if (current < proposed) return "arrow-up";
  return "dash";
};
